import "./input-with-icon-button.component.scss";

import { memo } from "react";
import { useTranslation } from "react-i18next";

const InputWithIconButton = props => {
  const { t } = useTranslation();

  const {
    id,
    type,
    name,
    value,
    inputClassName,
    placeholder,
    autoComplete,
    htmlFor,
    style,
    isInvalid,
    isHide,
    dataBsToggleOnInput, // for toggling dropdown once clicking on input.
    dataBsToggleOnButton, // for toggling dropdown once clicking on button.
    disabled,
    buttonIcon,
    buttonClassName,
    onClick,
    onChange,
    onFocus,
    onBlur,
    onKeyDown,
    buttonOnClick,
    children, // for displaying dropdown modal purpose.
    readOnly,
    ...other
  } = props;

  const classNameList = {
    "invalid": "invalid",
    "disabled": "disabled"
  }

  const invalidClassName = !!isInvalid ? classNameList["invalid"] : "";
  const disabeldClassName = !!disabled ? classNameList["disabled"] : "";
  const currentButtonIcon = !!buttonIcon ? buttonIcon : '';
  const currentButtonClassName = !!buttonClassName ? buttonClassName : 'btn-dropdown dropdown-toggle';
  const currentValue = value === null || value === undefined ? '' : value;
  const currentDataBsToggleOnInput = dataBsToggleOnInput ? 'dropdown' : '';
  const currentDataBsToggleOnButton = dataBsToggleOnButton ? 'dropdown' : '';
  const currentDataBsAutoClose = dataBsToggleOnInput || dataBsToggleOnButton ? 'outside' : ''; // not to auto-close modal once clicking inside.
  const dropdownChildren = (dataBsToggleOnInput || dataBsToggleOnButton) && children || null;

  return (
    <>
      {!isHide &&
        <div className={`input-with-icon-button-container input-container ${invalidClassName} ${disabeldClassName}`} style={style}>
          <input
            id={id}
            type={type || 'text'}
            name={name}
            value={currentValue}
            className={inputClassName}
            placeholder={t(placeholder)}
            autoComplete={autoComplete}
            disabled={disabled}
            readOnly={!!readOnly}
            data-bs-toggle={currentDataBsToggleOnInput}
            data-bs-auto-close={currentDataBsAutoClose}
            data-bs-display='static'
            onClick={onClick}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
            {...other}
          />
          <button
            type="button"
            className={`btn btn-default ${currentButtonClassName} ${currentButtonIcon}`}
            disabled={disabled}
            data-bs-toggle={currentDataBsToggleOnButton}
            data-bs-auto-close={currentDataBsAutoClose}
            data-bs-display='static'
            onClick={buttonOnClick}>
          </button>
          {dropdownChildren}
        </div>
      }
    </>
  )
};

export default memo(InputWithIconButton);